export default "https://d1e6s5z4lzmgxx.cloudfront.net/9448f7a6-2ffc-48da-926d-72a27a448f00/images/mute-icon.svg?a862c5724da7cdd59c1b5303fb3e9814";